module.exports = __webpack_public_path__ + "img/serve16.5c2333b9.png";